<template>
    <div id="main-content">
        <div class="container-fluid">
            <div class="block-header">
                 <bread-crumb></bread-crumb>
            </div>
            <div class="chart-section">
                <EChartComponent />
            </div>
            <div class="row clearfix">
             
            </div>
            <div class="row clearfix">
                
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from '@/components/BreadCrumb'
import EChartsComponent from '@/components/admin/dashboard/EChartComponent.vue'
export default {
    name: 'IndexComponent',
    components: {
        BreadCrumb,
        'EChartComponent': EChartsComponent
    },methods:{
       
    },
    data (){
        return{
            
        }
    },created(){
         
    },beforeUnmount() {
        
    }, 
}
</script>
<style scoped>

</style>